import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS} from './_base';

import I_OOODAYS from '../interfaces/I_OOODAYS';
import {
  getOOODaysResponse,
  putOOODayResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- COLLABORATEURS
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  from?: string;
  to?: string;
}
/**
 * Récupère la liste des ooo days
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,dispatch,state,from,to}:I_GET_PARAMS):Promise<I_OOODAYS> => {
  logger.debug('ApiServices - getOOODays - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getOOODaysResponse({accessToken:usedAccessToken,from,to});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getOOODays - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_OOODAYS = await response.json();
  logger.debug('ApiServices - getOOODays - ok, returned body',body);
  return body;
};


interface I_PUT_OOODAY_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  date: string,
  value: number,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Met à jour un type d'activité
 * @param param0
 * @returns
 */
const update = async ({accessToken,refreshToken,date,value,dispatch,state}:I_PUT_OOODAY_PARAMS):Promise<string> => {
  logger.debug('ApiServices - updateOOODay - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    date === undefined || date === null || date.trim() === '') {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing date',
      errorMessage: 'Missing date to put ooodays',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putOOODayResponse({accessToken:usedAccessToken,date,value});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateOOODay - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateOOODay - ok, returned body',body);
  logger.info(...formatInfo('OOODay updated!'));
  return body;
};

const ooodaysServices = {
  getList,
  update,
};

export default ooodaysServices;
